import React from 'react';
import PropTypes from 'prop-types';
import { Icon as IconButton } from '@vds/icons';

const Icon = (props) => {
  const { id, color, name, size, surface, ariaHidden } = props;
  return (
    <IconButton
      name={name}
      id={id}
      color={color}
      size={size}
      surface={surface}
      ariaHidden={ariaHidden}
    />
  );
};

export default Icon;
Icon.propTypes = {
  color: PropTypes.any,
  id: PropTypes.any,
  size: PropTypes.any,
  surface: PropTypes.any,
  name: PropTypes.any,
  ariaHidden: PropTypes.any,
};
